import { h } from "preact";
import { Text } from "preact-i18n";
interface Props {
    initialBelowMinimum: boolean;
    selectedBelowMinimum: boolean;
    zipCodeAreaMinCount?: number;
}
const SelectionWarnings = ({
    initialBelowMinimum,
    selectedBelowMinimum,
    zipCodeAreaMinCount,
}: Props) => (
    <>
        {initialBelowMinimum && zipCodeAreaMinCount ? (
            <Text
                id="general.messages.zipCodeAreaLimitError"
                fields={{
                    limit: zipCodeAreaMinCount,
                }}
            >
                {`At least ${zipCodeAreaMinCount} addresses should be selected per postcode area/route region. Adjust your search area by increasing the radius or adding a second selection within the guide region`}
            </Text>
        ) : selectedBelowMinimum && zipCodeAreaMinCount ? (
            <Text
                id="general.messages.zipCodeAreaSelectionLimitError"
                fields={{
                    limit: zipCodeAreaMinCount,
                }}
            >
                {`At least ${zipCodeAreaMinCount} addresses should be selected per postcode area/route region.`}
            </Text>
        ) : null}
    </>
);
export default SelectionWarnings;
